import React, { useState } from 'react';
import { toast } from 'react-hot-toast';
import { LuTag, LuPencil } from 'react-icons/lu';
import { guardarOferta } from '../../utils/ofertaMantenimiento';

const INPUT = 'w-16 h-9 px-2 rounded-lg bg-chip text-body font-black text-ink text-center outline-none';

// La oferta que va en el mensaje (20-oct-2026): descuento y en cuántos días tiene que coordinar.
// Se guarda en el backend (Ajustes de rentabilidad), así es la misma en el celu y en la compu.
export default function OfertaConfig({ oferta, onCambio }) {
    const [editando, setEditando] = useState(false);
    const [dto, setDto] = useState(String(oferta.ofertaDescuento));
    const [dias, setDias] = useState(String(oferta.ofertaVigenciaDias));
    const [guardando, setGuardando] = useState(false);

    const abrir = () => { setDto(String(oferta.ofertaDescuento)); setDias(String(oferta.ofertaVigenciaDias)); setEditando(true); };
    const guardar = async () => {
        setGuardando(true);
        try {
            onCambio(await guardarOferta({ ofertaDescuento: Number(dto) || 0, ofertaVigenciaDias: Number(dias) || 15 }));
            setEditando(false);
            toast.success('Oferta guardada');
        } catch (e) {
            toast.error(e?.response?.data?.mensaje || 'No se pudo guardar');
        } finally { setGuardando(false); }
    };

    if (!editando) {
        return (
            <button type="button" onClick={abrir}
                className="w-full mb-3 flex items-center gap-2 px-3 h-11 rounded-xl bg-card border border-black/[0.07] dark:border-white/[0.07] text-left active:scale-[0.99]">
                <LuTag size={15} className="text-muted shrink-0" />
                <span className="flex-1 min-w-0 text-caption text-secondary truncate">
                    {Number(oferta.ofertaDescuento) > 0
                        ? <>Oferta: <b className="text-ink">{oferta.ofertaDescuento}% de descuento</b> si coordina en {oferta.ofertaVigenciaDias} días</>
                        : 'Sin descuento en el mensaje'}
                </span>
                <LuPencil size={14} className="text-muted shrink-0" />
            </button>
        );
    }
    return (
        <div className="mb-3 p-3 rounded-xl bg-card border border-black/[0.07] dark:border-white/[0.07] space-y-2.5">
            <div className="flex flex-wrap items-center gap-2 text-caption text-secondary">
                <input className={INPUT} inputMode="numeric" value={dto} onChange={e => setDto(e.target.value.replace(/\D/g, '').slice(0, 2))} aria-label="Descuento" />
                <span>% de descuento si coordina en</span>
                <input className={INPUT} inputMode="numeric" value={dias} onChange={e => setDias(e.target.value.replace(/\D/g, '').slice(0, 2))} aria-label="Días" />
                <span>días</span>
            </div>
            <p className="text-label text-muted">Con 0% el mensaje va sin descuento.</p>
            <div className="flex gap-2">
                <button type="button" onClick={() => setEditando(false)} className="flex-1 h-10 rounded-lg bg-chip text-label font-black text-secondary">Cancelar</button>
                <button type="button" onClick={guardar} disabled={guardando} className="flex-1 h-10 rounded-lg bg-[#C9341F] text-white text-label font-black disabled:opacity-50">{guardando ? 'Guardando…' : 'Guardar'}</button>
            </div>
        </div>
    );
}
